console.log("Locaso: Vendors shim loaded (code splitting disabled in dev)");
